import axios from 'axios';

export const idsApiClient = axios.create({
    baseURL: `${import.meta.env.VITE_APP_API_URL}`,
    headers: {
        'accept-version': '2.0'
    }
});
